(() => {
  'use strict';
  const config = window.VAGBoosterContactRouting;
  if (!config || !['FR', 'DE'].includes(config.country) || window.VAGBoosterMarketContactLoaded) return;
  window.VAGBoosterMarketContactLoaded = true;
  const number = config.number.replace(/\D/g, '');
  const smsText = /\bSMS(?:-a|em|y|ów)?\b/gi;
  const rawFieldName = name => (name.match(/^contact\[(.*)\]$/)?.[1] || name).trim();
  const labels = {
    'imię': config.labels.name, 'imie': config.labels.name, 'name': config.labels.name,
    'nazwa': config.labels.name, 'produkt': config.labels.product, 'link': config.labels.link,
    'model auta': config.labels.car, 'marka i model': config.labels.car,
    'kod silnika': config.labels.engine, 'numer ecu': config.labels.ecu,
    'wiadomość': config.labels.message, 'message': config.labels.message,
    'komentarz': config.labels.message, 'comment': config.labels.message,
    'body': config.labels.message, 'cel': config.labels.target, 'vin': config.labels.vin
  };
  const fieldLabel = (form, name) => {
    const field = Array.from(form.elements).find(element => element.name === name);
    const visibleLabel = field?.labels?.[0]?.textContent?.trim();
    const raw = rawFieldName(name);
    return visibleLabel || labels[raw.toLowerCase()] || raw;
  };
  const isContactForm = form => form instanceof HTMLFormElement && (
    form.matches('[data-vb-sms-form], [data-vb-whatsapp-form]') ||
    form.querySelector('input[name="form_type"][value="contact"]') !== null
  );
  const whatsappUrl = message => 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
  const messageFor = form => {
    const data = new FormData(form);
    const topic = String(data.get('contact[temat]') || form.dataset.vbTopic || config.topic).trim();
    const lines = [topic];
    const product = String(data.get('contact[produkt]') || form.dataset.vbProduct || '').trim();
    const link = String(data.get('contact[link]') || form.dataset.vbProductUrl || '').trim();
    if (product) lines.push(config.labels.product + ': ' + product);
    if (link) lines.push(config.labels.link + ': ' + link);
    for (const [name, raw] of data.entries()) {
      if (['contact[temat]', 'contact[produkt]', 'contact[link]', 'form_type', 'utf8', 'contact[tags]'].includes(name)) continue;
      if (typeof raw !== 'string') continue;
      const value = raw.trim();
      if (value) lines.push(fieldLabel(form, name) + ': ' + value);
    }
    return lines.join('\n');
  };
  const convertLink = link => {
    const href = link.getAttribute('href') || '';
    if (!/^sms:/i.test(href) && !/^tel:/i.test(href)) return;
    const recipient = href.replace(/^(sms|tel):/i, '').split(/[?&;]/)[0].replace(/\D/g, '');
    if (recipient && recipient !== number && recipient !== number.slice(2)) return;
    const match = href.match(/[?&]body=([^&#]*)/i);
    let message = config.topic;
    if (match) {
      try { message = decodeURIComponent(match[1].replace(/\+/g, ' ')); }
      catch { message = match[1]; }
    }
    link.setAttribute('href', whatsappUrl(message));
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');
    const aria = link.getAttribute('aria-label');
    if (aria && /sms/i.test(aria)) link.setAttribute('aria-label', config.button);
  };
  const prepareForm = form => {
    if (!isContactForm(form)) return;
    form.removeAttribute('data-vb-sms-form');
    form.setAttribute('data-vb-whatsapp-form', '');
    form.dataset.whatsappNumber = number;
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(button => {
      if (button instanceof HTMLInputElement) button.value = config.button;
      else button.textContent = config.button;
    });
    form.querySelectorAll('.vb-sms-note').forEach(note => { note.textContent = config.note; });
  };
  const prepare = root => {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches('a[href]')) convertLink(root);
    root.querySelectorAll('a[href^="sms:" i], a[href^="tel:" i]').forEach(convertLink);
    if (isContactForm(root)) prepareForm(root);
    root.querySelectorAll('form').forEach(prepareForm);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script, style, textarea, input, [contenteditable="true"]')) continue;
      const next = node.nodeValue.replace(smsText, 'WhatsApp');
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  };
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!isContactForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!form.reportValidity()) return;
    window.location.assign(whatsappUrl(messageFor(form)));
  }, true);
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link) convertLink(link);
  }, true);
  const init = () => {
    prepare(document.body);
    const observer = new MutationObserver(records => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'characterData') roots.add(record.target.parentElement);
        else for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) roots.add(node);
          else if (node.nodeType === Node.TEXT_NODE) roots.add(node.parentElement);
        }
      }
      for (const root of roots) prepare(root);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
